// Generated from src/img/svg/emptyFolder.svg

export const EmptyFolder = (props) => {
  return (
    <svg height="204" viewBox="0 0 204 204" width="204" {...props}>
      <defs>
        <style>
          {
            ".emptyFolder_svg__a{fill:#bfbfbf}.emptyFolder_svg__b{fill:#fff}.emptyFolder_svg__d{fill:none;stroke:#bfbfbf}"
          }
        </style>
      </defs>
      <g transform="translate(-1486 -245)">
        <path
          className="emptyFolder_svg__a"
          d="m1502 292.075 21.866-37.488a19.32 19.32 0 0 1 16.692-9.587h120.766a7.247 7.247 0 0 1 6.26 10.9l-21.868 37.486a19.32 19.32 0 0 1-16.692 9.587h-120.767a7.246 7.246 0 0 1-6.257-10.898m127.026 20.56h-99.039v14.494a14.493 14.493 0 0 0 14.493 14.493h48.311l19.324 19.324h48.311a14.493 14.493 0 0 0 14.493-14.493V262.5l-20.857 35.754a29.09 29.09 0 0 1-25.038 14.381Z"
        />
        <path
          className="emptyFolder_svg__b"
          d="m1662 350.636 3.626 2.189-.962-4.125 3.2-2.775-4.215-.359-1.649-3.89-1.649 3.89-4.219.358 3.2 2.775-.962 4.125ZM1618 346h31v5h-31z"
        />
        <ellipse
          cx="102"
          cy="7"
          rx="102"
          ry="7"
          style={{ fill: "#eee" }}
          transform="translate(1486 435)"
        />
      </g>
      <path
        className="emptyFolder_svg__a"
        d="m106.458 180.169 16.206-4.007-14.178-8.813 1.194-16.664-12.756 10.76-15.436-6.247 6.245 15.438-10.758 12.754 16.663-1.194 8.814 14.178ZM40.53 140.965l6.613 1.909-3.246-6.067 3.86-5.71-6.773 1.214-4.224-5.41-.95 6.8-6.473 2.335 6.197 3.009.225 6.877ZM158.037 161.832l11.166.023-7.776-8.016 3.472-10.62-10.02 4.919-9.008-6.553 1.556 11.03-9.047 6.538 11.008 1.922 3.426 10.627Z"
      />
      <path
        className="emptyFolder_svg__d"
        d="M51.48 146.643a11.21 11.21 0 0 1-12.814.97M41.904 151.596a10.14 10.14 0 0 1-7.356-3.83"
      />
    </svg>
  );
};
